import { useCallback, useEffect, useState } from 'react';

const DEFAULT_SECONDS = 60;

export function useVerifyCodeCooldown(seconds = DEFAULT_SECONDS) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const timer = window.setTimeout(() => setRemaining((value) => value - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [remaining]);

  const start = useCallback(() => setRemaining(seconds), [seconds]);
  const active = remaining > 0;

  return { remaining, active, start };
}
